import { patchRequest } from '@/core';
import { settings } from '@/requests';

export default async function saveSettings(systemSettings) {
	let url = settings.updateSetting();
	try {
		let response = await patchRequest(url, '',  systemSettings);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}